import request from '@/lib/request'

export default {
  // 获取壳牌卡列表
  getList(params) {
    return request.post_proxy('admin/shell_card/getLists', params).then(res => res.data)
  },
  
  // 获取壳牌卡详情
  getDetail(params) {
    return request.post_proxy('admin/shell_card/getDetailInfo', params).then(res => res.data)
  },
  
  // 保存壳牌卡（添加或编辑）
  save(params) {
    return request.post_proxy('admin/shell_card/save', params).then(res => res.data)
  },
  
  // 解锁卡片
  unlockCard(params) {
    return request.post_proxy('admin/shell_card/unlockCard', params).then(res => res.data)
  },
  
  // 同步余额
  syncBalance(params) {
    return request.post_proxy('admin/shell_card/syncBalance', params).then(res => res.data)
  },
  
  // 设置状态
  setStatus(params) {
    return request.post_proxy('admin/shell_card/setStatus', params).then(res => res.data)
  },
  
  // 删除卡片
  delete(params) {
    return request.post_proxy('admin/shell_card/delete', params).then(res => res.data)
  },
  
  // 批量导入
  batchImport(params) {
    return request.post_proxy('admin/shell_card/batchImport', params).then(res => res.data)
  },
  
  // 获取壳牌订单记录列表
  getOrderList(params) {
    return request.post_proxy('admin/shell_order_record/getLists', params).then(res => res.data)
  },
  
  // 获取壳牌订单详情
  getOrderDetail(params) {
    return request.post_proxy('admin/shell_order_record/getDetail', params).then(res => res.data)
  },
  
  // 重新检测订单核销状态
  recheckVerification(params) {
    return request.post_proxy('admin/shell_order_record/recheckVerification', params).then(res => res.data)
  },
  
  // 保存订单标记
  saveMark(params) {
    return request.post_proxy('admin/shell_order_record/saveMark', params).then(res => res.data)
  }
}
